export const PAIR_LESSONS_PLUSES_LIST = [{
  header: 'Занятия с коллегой',
  text: 'Такие занятия позволяют практиковать не&nbsp;только софтовые, но&nbsp;и&nbsp;технические собеседования на&nbsp;английском'
}, {
  header: 'Учебный план',
  text: 'Создается с&nbsp;учетом ваших целей, сроков и&nbsp;интересов'
}, {
  header: 'Уникальность парных занятия',
  text: 'В&nbsp;отличие от&nbsp;групповых занятий, расписание более гибкое&nbsp;&mdash; главное, чтобы время подходило и&nbsp;вам, и&nbsp;вашему напарнику'
}, {
  header: 'Интерактивные платформы',
  text: 'На занятиях мы используем Miro, Progressme, онлайн словари, аутентичные материалы: видео и&nbsp;статьи на&nbsp;актуальные вам темы'
}];